import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import MembershipSection from './components/MembershipSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const webSiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '91网',
  url: 'https://www.91wang.com',
  description: '91网是您的首选平台，提供全面的资源整合与服务入口。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.91wang.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '91网',
  url: 'https://www.91wang.com',
  description: '91网 - 资源整合与服务平台',
  foundingDate: '2018',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-9191',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    document.title = '91网-官方入口与核心功能导航';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        '91网是您的首选平台，提供全面的资源整合与服务入口。本页详细介绍91网的核心功能、使用指南、会员权益及常见问题，帮助用户快速上手，充分享受91网带来的优质体验与便捷服务。'
      );
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        'content',
        '91网,91网官方入口,91网注册登录,91网会员权益,91网使用指南,91网资源整合,91网常见问题'
      );
    }
  }, []);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webSiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <ArticlesSection />
        <MembershipSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}